module.exports = __webpack_public_path__ + "img/wyb-nav.bbbb568.svg";